import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import * as amplitude from 'amplitude-js';

import { throwError } from '@/utils';
import { RoleDTO, PermissionDTO } from '@/api';
import services from '@/services';

@Module({ name: 'RolesModule' })
export default class RolesModule extends VuexModule {
  listLoading = false;

  list: RoleDTO[] = [];

  @Mutation
  setListLoading(state: boolean) {
    this.listLoading = state;
  }

  @Mutation
  setRoles(roles: RoleDTO[]) {
    this.list = roles;
  }

  @Mutation
  setRolePermissions({ roleId, permissions } :
      {roleId: number; permissions: Array<PermissionDTO>}) {
    const index = this.list.findIndex(role => role.id === roleId);
    if (index > -1) {
      this.list[index].permissions = permissions;
    }
  }

  @Action({ rawError: true })
  async fetchRoles() {
    try {
      this.setListLoading(true);
      const { data: roles } = await services
        .userService()
        .userEndpointGetAllRoles();
      this.setRoles(roles);
      amplitude.getInstance().logEvent('Загрузка ролей');
      return roles;
    } catch (e) {
      return throwError('Ошибка запроса ролей')(e);
    } finally {
      this.setListLoading(false);
    }
  }

  @Action({ rawError: true })
  async saveRolePermissions({ roleId, permissions } :
      {roleId: number; permissions: Array<PermissionDTO>}) {
    try {
      const permissionsId = (permissions || []).map<string>(p => p.id as string);
      services.userService()
        .userEndpointSetRolePermissions(roleId, permissionsId);
      this.setRolePermissions({ roleId, permissions });
      amplitude.getInstance().logEvent('Сохранение доступов', { roleId, permissions });
      return permissionsId;
    } catch (e) {
      return throwError('Ошибка сохранения доступов')(e);
    } finally {
      this.setListLoading(false);
    }
  }
}
